import { ref } from 'vue';
import { defineStore } from 'pinia';
import useAxiosInstance from '@/composables/axiosInstance';
import { Pronoun, PronounResponse } from '@/interfaces/CBW/PronounResponse';
import useUISessionStore from '@/stores/ui-session';

interface State {
    pronouns : Pronoun[];
}

const useHRAdminPronounStore = defineStore({
  id: 'hr-admin-pronouns',
  state: () => ref<State>({
    pronouns: [],
  }),
  actions: {
    async init() {
      await this.getPronouns();
    },
    async getPronouns() : Promise<void> {
      try {
        const { data } = await useAxiosInstance.get<PronounResponse>('/api/pronouns');

        this.$state = {
          ...this.$state,
          pronouns: data.results,
        };
      } catch (error : any) {
        console.error(error);
      }
    },
    async insertPronoun(pronoun : string) : Promise<null | Pronoun> {
      try {
        const uiStore = useUISessionStore();

        const { status, data } = await useAxiosInstance.put<Pronoun>('/api/pronouns', {
          pronoun: pronoun.trim(),
          CreatedByEmpCode: uiStore.user.empCode,
        });

        if (status === 200) {
          this.$state = {
            ...this.$state,
            pronouns: [...this.$state.pronouns, data],
          };
          return data;
        }
      } catch (error : any) {
        console.error(error);
      }
      return null;
    },
    async updatePronoun(pronoun : Pronoun) : Promise<Pronoun | null> {
      try {
        const updatedPronoun = {
          ...pronoun,
          description: pronoun.description.trim()
        }

        const uiStore = useUISessionStore();

        const { status } = await useAxiosInstance.patch<Pronoun>('/api/pronouns', {
          id: updatedPronoun.id,
          pronoun: updatedPronoun.description,
          ModifiedByEmpCode: uiStore.user.empCode,
        });

        if (status === 200) {
          this.$state = {
            ...this.$state,
            pronouns: [...this.$state.pronouns.map((p) => {
              if (p.id === updatedPronoun.id) {
                return updatedPronoun;
              }
              return p;
            })],
          };

          return updatedPronoun;
        }
      } catch (error : any) {
        console.error(error);
      }

      return null;
    },
    async deletePronoun(id : number) : Promise<void> {
      try {
        const uiStore = useUISessionStore();

        const { status } = await useAxiosInstance.delete<Pronoun>(`/api/pronouns/${id}`);

        if (status === 200) {
          this.$state = {
            ...this.$state,
            pronouns: [...this.$state.pronouns.filter((p) => {
              if (p.id !== id) {
                return p;
              }
            })],
          };
        }
      } catch (error : any) {
        console.error(error);
      }
    },    
  },
});

export default useHRAdminPronounStore;
